export default class YearCount {

    static init() {
        // Získání všech elementů se třídou js-year-count
        const yearCountElements = document.querySelectorAll('.js-year-count');

        // Ověření, zda vůbec nějaké elementy existují
        if (yearCountElements.length > 0) {
        
            // Datum, kdy začíná počítání
            const startDate = new Date('2002-11-08');
            
            // Dnešní datum
            const today = new Date();

            // Pro každý element spočítáme počet roků
            yearCountElements.forEach(element => {
                
                // Výpočet rozdílu v letech
                const yearsDifference = today.getFullYear() - startDate.getFullYear();
                
                // Ověření, zda již proběhl 8. listopad tohoto roku
                const hasHadBirthdayThisYear = today.getMonth() > startDate.getMonth() || 
                                            (today.getMonth() === startDate.getMonth() && today.getDate() >= startDate.getDate());

                // Pokud neproběhl, odečteme jeden rok
                const years = hasHadBirthdayThisYear ? yearsDifference : yearsDifference - 1;

                // Vložení výsledku do elementu
                element.textContent = years;
            });
        }
    }
}